module.exports = __webpack_public_path__ + "assets/img/king-hit.7fca142e.png";